import React from 'react'

const { Provider, Consumer } = React.createContext(true)

export { Provider, Consumer }
